<template>
  <div class="">
    <div class="row justify-content-between">
      <div class="col-auto"></div>
      <div class="col-auto">
        <button
          @click="$router.push({ name: 'vehicles-create' })"
          class="btn btn-primary"
        >
          <i class="bi bi-plus-square"></i>
          Créer
        </button>
      </div>
    </div>
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Référence Nº</th>
          <th scope="col">Nom</th>
          <th scope="col">Date d'vehicle</th>
          <th scope="col">Montant</th>
          <th scope="col">M. Payé</th>
          <th scope="col">M. à Régler</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(vehicle, index) in vehicles" :key="index++">
          <td>
            {{ index }}
          </td>
          <td class="p-0 m-0">
            <button
              class="btn btn-link ms-2"
              @click="
                $router.push({
                  name: 'profile-vehicle',
                  params: {
                    reference: vehicle.reference,
                  },
                })
              "
            >
              {{ vehicle.reference }}
            </button>
          </td>
          <td>
            {{ vehicle.fullName }}
          </td>
          <td>{{ vehicle.date }}</td>
          <td class="text-warning">{{ vehicle.amount }}</td>
          <td class="text-success">
            {{ vehicle.payrollAmount }}
          </td>
          <td class="text-danger">
            <button class="btn">
              <i class="bi bi-coin fs-5"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      search_value: "",
      addedToday: false,
      sortValue: "",
    };
  },
  computed: {
    ...mapGetters("vehicle", {
      vehicles: "getVehicles",
    }),
  },
  mounted() {
    this.$store.dispatch("vehicle/getAll");
  },
  methods: {
    async search(value) {
      return await this.$store.commit("vehicle/search", value);
    },
    async refresh() {
      return await this.$store.dispatch("vehicle/getAll");
    },

    async listVehicles(checkbox) {
      if (checkbox == true) {
        console.log(checkbox);
        return await this.$store.commit("vehicle/getTodays");
      } else {
        return await this.$store.dispatch("vehicle/getAll");
      }
    },
    async sort(value) {
      return await this.$store.commit("vehicle/sort", value);
    },
  },
};
</script>
